import React from 'react';
import * as Icons from 'lucide-react';

interface NavIconProps {
  name: string;
  className?: string;
}

const NavIcon: React.FC<NavIconProps> = ({ name, className = "w-4 h-4" }) => {
  const IconComponent = Icons[name as keyof typeof Icons];
  return IconComponent ? <IconComponent className={className} /> : null;
};

export default NavIcon;